import { render, staticRenderFns } from "./channel2022.vue?vue&type=template&id=357f2eb0&scoped=true&"
import script from "./channel2022.vue?vue&type=script&lang=js&"
export * from "./channel2022.vue?vue&type=script&lang=js&"
import style0 from "./channel2022.vue?vue&type=style&index=0&id=357f2eb0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "357f2eb0",
  null
  
)

export default component.exports